import React, { useState } from "react";
import "./cssBoiler.css";
import "./ModernAboutSection.css";
import {
  HiOutlineRocketLaunch,
  HiOutlineVideoCamera,
  HiOutlineBolt,
  HiOutlineCpuChip,
  HiOutlineClock,
  HiOutlineCodeBracket,
  HiOutlineStar,
  HiOutlineGlobeAlt,
} from "react-icons/hi2";

function ModernAboutSection() {
  const [hoveredCard, setHoveredCard] = useState(null);

  const aboutCards = [
    {
      id: 1,
      title: "My Journey",
      icon: HiOutlineRocketLaunch,
      description:
        "Started coding at 14, building front-end websites. Today, I architect scalable systems with Docker, Azure, Redis, BullQ, and microservices.",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      stats: "4+ Years",
    },
    {
      id: 2,
      title: "Video Platform",
      icon: HiOutlineVideoCamera,
      description:
        "Built a full-stack YouTube-like video platform from scratch. Implemented HLS video streaming with Node.js and FFmpeg, cutting video load times by 40%.",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      stats: "40% Faster",
    },
    {
      id: 3,
      title: "Real-time Features",
      icon: HiOutlineBolt,
      description:
        "Integrated Server-Sent Events (SSE) for real-time upload progress tracking, significantly improving user experience and engagement.",
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      stats: "Real-time",
    },
    {
      id: 4,
      title: "Smart Algorithms",
      icon: HiOutlineCpuChip,
      description:
        "Developed an 'Up Next' recommendation algorithm that increased average watch time by 15%, and built adaptive quality streaming based on network conditions.",
      gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      stats: "15% Boost",
    },
  ];

  const achievements = [
    { number: "4+", label: "Years Experience", icon: HiOutlineClock },
    { number: "10+", label: "Projects Built", icon: HiOutlineCodeBracket },
    { number: "100%", label: "Client Satisfaction", icon: HiOutlineStar },
    { number: "24/7", label: "Available", icon: HiOutlineGlobeAlt },
  ];

  return (
    <div className="modern-about-section" id="about">
      <div className="about-container">
        <div className="about-header">
          <div className="section-badge">
            <span>Personal Story</span>
          </div>
          <h2 className="about-title">
            A <span className="gradient-text">Bit</span> About Me
          </h2>
        </div>

        <div className="about-content">
          <div className="about-main-text">
            <div className="text-container">
              <p className="main-description">
                Started coding at 14. Now I architect systems that handle
                millions of users. React, Node.js, Docker, Azure, Redis, BullQ,
                microservices — I turn complex problems into elegant solutions
                that actually work. No hype, no fluff, just code that delivers
                results when it matters most.
              </p>
            </div>
          </div>

          <div className="about-cards-grid">
            {aboutCards.map((card, index) => (
              <div
                key={card.id}
                className={`about-card ${
                  hoveredCard === card.id ? "hovered" : ""
                }`}
                onMouseEnter={() => setHoveredCard(card.id)}
                onMouseLeave={() => setHoveredCard(null)}
                style={{ "--delay": `${index * 0.1}s` }}
              >
                <div className="card-inner">
                  <div className="card-header">
                    <div
                      className="card-icon"
                      style={{ background: card.gradient }}
                    >
                      <card.icon className="card-icon-svg" />
                    </div>
                    <div className="card-stats">{card.stats}</div>
                  </div>

                  <h3 className="card-title">{card.title}</h3>
                  <p className="card-description">{card.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="achievements-section">
          <div className="achievements-grid">
            {achievements.map((achievement, index) => (
              <div
                key={index}
                className="achievement-item"
                style={{ "--delay": `${index * 0.1}s` }}
              >
                <div className="achievement-icon">
                  <achievement.icon className="achievement-icon-svg" />
                </div>
                <div className="achievement-number">{achievement.number}</div>
                <div className="achievement-label">{achievement.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModernAboutSection;
